import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppBar, Toolbar, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import colors from '../../../../scss/colors';
import logo from '../../../../Assets/images/Airswift Primary Logo (Gradient Bird Only).png';
import classes from './Header.module.scss';
import ProfileButton from '../ProfileButton/ProfileButton';
import { getTandEPendingCounts } from '../../../../actions/timesheet';

export default function Header({ openCloseHandler }) {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const accessTo = useSelector((state) => state.accessToParts);
  const pendingTandECounts = useSelector((state) => state.timesheet?.tandecounts);

  const handleClickOnCounter = () => {
    setSearchParams({ status: 'Pending' });
  };

  useEffect(() => {
    if (accessTo.tAndEApprover) {
      dispatch(getTandEPendingCounts());
    }
  }, [accessTo]);

  const getAreaLable = () => {
    const path = window.location.pathname;
    if (path.includes('/my-profile')) {
      return t('common.navigationheaders.myprofile');
    }

    if (path.includes('/jobs/') || path.includes('/Jobs/')) {
      return t('common.navigationheaders.job');
    }

    if (path.includes('/timesheet/')) {
      return t('common.navigationheaders.timesheet');
    }

    if (path.includes('/expense/')) {
      return t('common.navigationheaders.expense');
    }

    switch (path.split('/dashboard')[1]) {
      case '/profile-builder-one':
      case '/profile-builder-two':
      case '/profile-builder-three':
      case '/profile-builder-four':
      case '/profile-builder-five':
      case '/profile-builder-six':
      case '/profile-builder-seven':
        return t('common.navigationheaders.profilebuilder');
      case '/tifo':
        return t('common.navigationheaders.onboarding');
      case '/expenses':
        return (
          <>
            {t('common.navigationheaders.expenses')}
            {pendingTandECounts?.PendingClaimsCount ? (
              <span className={classes.withCursor} role="presentation" onClick={handleClickOnCounter}>
                <Typography display="inline" mx={3} sx={{ borderLeft: 1, borderColor: colors.LIGHT_GREY }} />
                <strong> {pendingTandECounts?.PendingClaimsCount} </strong> pending
              </span>
            ) : null}
          </>
        );
      case '/timesheets':
        return (
          <>
            {t('common.navigationheaders.timesheets')}
            {pendingTandECounts?.PendingTimesheetCount ? (
              <span className={classes.withCursor} role="presentation" onClick={handleClickOnCounter}>
                <Typography display="inline" mx={3} sx={{ borderLeft: 1, borderColor: colors.LIGHT_GREY }} />
                <strong> {pendingTandECounts?.PendingTimesheetCount}</strong> pending
              </span>
            ) : null}
          </>
        );
      case '/jobs':
      case '/Jobs':
        return t('common.navigationheaders.jobs');
      case '/create-timesheet':
        return t('common.navigationheaders.createtimesheet');
      case '/create-claim':
        return t('common.navigationheaders.createclaim');
      default:
        return t('common.navigationheaders.dashboard');
    }
  };

  return (
    <div className={classes.headerContainer}>
      <AppBar component="nav" sx={{ backgroundColor: 'white' }}>
        <Toolbar sx={{ '&.MuiToolbar-root': { minHeight: '74px' } }}>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, color: colors.NAVY_BLUE }}
            onClick={openCloseHandler}
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.logoContainer}>
            <Link to="/dashboard">
              <img alt="logo" src={logo} width="58px" height="40px" />
            </Link>
            <p className={classes.pageLabel}>{getAreaLable()}</p>
          </div>
          <ProfileButton />
        </Toolbar>
      </AppBar>
    </div>
  );
}
